import React from "react";

export const VerifiedTag = (): JSX.Element => (
  <span className="text-success">Verified</span>
);
export const UnverifiedTag = (): JSX.Element => (
  <span className="text-danger">Unverified</span>
);
